import { useId } from 'react';

import styled from '@emotion/styled';

interface Props {
  imageSrc: string;
  rank: number;
}
const RankingImage = ({ imageSrc, rank }: Props) => {
  const id = useId();
  return (
    <SRankImageWrapper>
      {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="130"
        height="148"
        viewBox="0 0 130 148"
        fill="none"
      >
        <path
          d="M16 0C7.16344 0 0 7.16344 0 16V99C0 104.523 4.47715 109 10 109H17C25.8366 109 33 116.163 33 125V138C33 143.523 37.4771 148 43 148H114C122.837 148 130 140.837 130 132V16C130 7.16344 122.837 0 114 0H16Z"
          fill={`url(#pattern${uuid})`}
        />
        <path
          d="M0.5 16C0.5 7.43959 7.43959 0.5 16 0.5H114C122.56 0.5 129.5 7.43959 129.5 16V132C129.5 140.56 122.56 147.5 114 147.5H43C37.7533 147.5 33.5 143.247 33.5 138V125C33.5 115.887 26.1127 108.5 17 108.5H10C4.7533 108.5 0.5 104.247 0.5 99V16Z"
          stroke="#D8D8D8"
          strokeOpacity="0.3"
        />
        <defs>
          <pattern id={`pattern${uuid}`} patternContentUnits="objectBoundingBox" width="1" height="1">
            <use xlinkHref={`#image${uuid}`} transform="matrix(0.00352465 0 0 0.00309598 -0.134437 0)" />
          </pattern>
          <image id={`image${uuid}`} className="image" xlinkHref={imageSrc} />
        </defs>
      </svg>
      <span className="rank-number">{rank}</span> */}
      <svg xmlns="http://www.w3.org/2000/svg" width="130" height="148" viewBox="0 0 130 148" fill="none">
        <defs>
          <clipPath id={`clipPath`}>
            <path
              id={`path-${id}`}
              d="M16 0C7.16344 0 0 7.16344 0 16V99C0 104.523 4.47715 109 10 109H17C25.8366 109 33 116.163 33 125V138C33 143.523 37.4771 148 43 148H114C122.837 148 130 140.837 130 132V16C130 7.16344 122.837 0 114 0H16Z"
            />
          </clipPath>
        </defs>

        <image
          id={`image-${id}`}
          href={imageSrc}
          width="130"
          height="148"
          preserveAspectRatio="xMidYMid slice"
          clipPath="url(#clipPath)"
        />

        <path
          id={`border-${id}`}
          d="M0.5 16C0.5 7.43959 7.43959 0.5 16 0.5H114C122.56 0.5 129.5 7.43959 129.5 16V132C129.5 140.56 122.56 147.5 114 147.5H43C37.7533 147.5 33.5 143.247 33.5 138V125C33.5 115.887 26.1127 108.5 17 108.5H10C4.7533 108.5 0.5 104.247 0.5 99V16Z"
          stroke="#D8D8D8"
          strokeOpacity="0.3"
        />
      </svg>
      <span className="rank-number">{rank}</span>
    </SRankImageWrapper>
  );
};

const SRankImageWrapper = styled.article`
  position: relative;

  .rank-number {
    position: absolute;
    left: 6px;
    bottom: 9px;
    ${({ theme }) => theme.font.head4_rank};
    color: ${({ theme }) => theme.color.static.black};
  }

  .image {
    object-fit: cover;
  }
`;

export default RankingImage;
